import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { buttonVariants } from '@clatter/ui';
import { NgButton, NgErrorMessage } from '../../../UI';

const StyledActionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.spacing.small};

  button {
    max-width: 220px;
  }
`;

interface DocumentsGenerateButtonProps {
  disabled: boolean;
  onClick: () => void;
  errorMessage?: string | null;
  label: string | ReactNode;
}

export const DocumentsGenerateButton: FC<DocumentsGenerateButtonProps> = ({
  disabled,
  onClick,
  errorMessage,
  label,
}) => {
  return (
    <StyledActionContainer>
      <NgButton variant={buttonVariants.primary} disabled={disabled} onClick={onClick}>
        {label}
      </NgButton>

      <NgErrorMessage message={errorMessage} />
    </StyledActionContainer>
  );
};
